import React from "react"
import { Link } from "gatsby"
import { useAuth } from "../../providers/auth/AuthProvider"

function PaymentNotice() {
  const [state] = useAuth()

  return (
    <div className="bg-green-600 py-6 px-4">
      <div className="container mx-auto px-3 leading-tight">
        <h3 className="text-white font-bold mb-3">Action Required</h3>
        <p className="text-white m-0 mb-1">
          Your references have been submitted and we are pleased to welcome you
          to the BSSR. Please{" "}
          <Link
            className="font-bold underline"
            to={`/register/payment?uid=${state.user_id.replace("auth0|", "")}`}
          >
            click here
          </Link>{" "}
          to complete your membership.
        </p>
      </div>
    </div>
  )
}

export default PaymentNotice
